import getCustomAxios from "../Helpers/customAxios";
import { camelizeKeys, decamelizeKeys, decamelize } from "humps";
import {
  RHEA_CMS_RESOURCES_API_ENDPOINT,
  RHEA_CMS_RESOURCE_API_ENDPOINT,
} from "../Constants/API";

export function getResourcesListAPI(
  filtersMap = new Map(),
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // The following code will generate the query parameters for the url based on the map.
  let aURL = RHEA_CMS_RESOURCES_API_ENDPOINT;
  filtersMap?.forEach((value, key) => {
    // let decamelizedkey = decamelize(key);
    if (aURL.indexOf("?") > -1) {
      aURL += "&" + key + "=" + value;
    } else {
      aURL += "?" + key + "=" + value;
    }
  });

  axios
    .get(aURL)
    .then((successResponse) => {
      const responseData = successResponse.data.items;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function postReportCreateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.userId = data.userID;
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.targetHeartRate = parseFloat(data.targetHeartRate);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .post(RHEA_CMS_RESOURCES_API_ENDPOINT, decamelizedData)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function getReportDetailAPI(
  sessionTemplateID,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .get(RHEA_CMS_RESOURCE_API_ENDPOINT.replace("{id}", sessionTemplateID))
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Return the callback data.
      onSuccessCallback(responseData);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function putReportUpdateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.userId = data.userID;
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.targetHeartRate = parseFloat(data.targetHeartRate);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .put(
        RHEA_CMS_RESOURCE_API_ENDPOINT.replace("{id}", decamelizedData.id),
      decamelizedData
    )
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function deleteReportAPI(
  id,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .delete(RHEA_CMS_RESOURCE_API_ENDPOINT.replace("{id}", id))
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}
